import { Outlet } from 'react-router-dom';
import useGlobalState from '../../../Template/atoms/variables';
import { useEffect } from 'react';

const FileUploadOutlet = () => {
  const { setPendingApiCalls } = useGlobalState();

  useEffect(() => {
    triggerApiCalls();
  }, []);

  const triggerApiCalls = async () => {
    try {
    } finally {
    }
  };

  return <Outlet />;
};

export default FileUploadOutlet;
